import { render, staticRenderFns } from "./SmallDetailsNotification.vue?vue&type=template&id=394c9f23"
import script from "./SmallDetailsNotification.vue?vue&type=script&lang=ts"
export * from "./SmallDetailsNotification.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./SmallDetailsNotification.vue?vue&type=style&index=0&id=394c9f23&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports